
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqyUJMIOXuQsLEjmhzle2wBU7_458_45acBe9TlLcMArEWL5UMeta } from "/codebuild/output/src1349592404/src/src/pages/faq.vue?macro=true";
import { default as menuzFAx0cgZYpBGTVR_45rLM2m2LhWp4iSdGQY5Ppmc4Di_45QMeta } from "/codebuild/output/src1349592404/src/src/pages/menu.vue?macro=true";
import { default as indexjG9GtChtnwParDpx_xtPbchEsib1FSoNhG8j49kDyoMMeta } from "/codebuild/output/src1349592404/src/src/pages/index.vue?macro=true";
import { default as contactOicWY92_45VxQF9aZNpzXQxvScuDipegRE7kKLDI4vj_454Meta } from "/codebuild/output/src1349592404/src/src/pages/contact.vue?macro=true";
import { default as tutorialEXrJIDdaFN0sPgdNF3EXE7vd1ZCSrqbZV6doi9_45YYFsMeta } from "/codebuild/output/src1349592404/src/src/pages/tutorial.vue?macro=true";
import { default as agreementKGrE6EoB_QC0iw1t8gupMySkbqE_7gp3CwHwohkuecgMeta } from "/codebuild/output/src1349592404/src/src/pages/agreement.vue?macro=true";
import { default as about_45passmT3bx53hZoJiaL1UXee8vXC3fillLfXNRstcNiblnoIMeta } from "/codebuild/output/src1349592404/src/src/pages/about-pass.vue?macro=true";
import { default as indexp3f9FhehGFzCjkR_45eAhVldbrr88Kzu55DmyPJ6mMXNgMeta } from "/codebuild/output/src1349592404/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93J_fDOYjHHrJBuC2O17V_45dKR7VthFRNgyyO_mvsjxnqsMeta } from "/codebuild/output/src1349592404/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance_451Be9UzwKBYf0P6TC1bcR0_45TKbR2bODbu0RZ2o_R1FUMeta } from "/codebuild/output/src1349592404/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93fEeales7sd6vjEFiN2sYAIJozRNG8e400qKu1Vay6BAMeta } from "/codebuild/output/src1349592404/src/src/pages/notice/[id].vue?macro=true";
import { default as indexVMF4dSvM1Hz_459JhVJcfV_45Td_vR_45LBvsdLYd33uLmHnEMeta } from "/codebuild/output/src1349592404/src/src/pages/coupon/index.vue?macro=true";
import { default as index7m6CoD0Kn4Idc8_KERtUEAGLTr_vpMeKla3Rt0CxcosMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/index.vue?macro=true";
import { default as indexcouPAcrsbiFMHD_NYwvHdXkxsZzfX6gBhgTEpf1ZV20Meta } from "/codebuild/output/src1349592404/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93has_9E_8wWzg2Ygufra1BEwoBQb5j4I7atK2d8CrVN0Meta } from "/codebuild/output/src1349592404/src/src/pages/parking/[id].vue?macro=true";
import { default as indexMlaVmAl2RYqCLKKc3FKF_p1h64uj5gmypRF22D7MJv4Meta } from "/codebuild/output/src1349592404/src/src/pages/history/index.vue?macro=true";
import { default as indexpXF1UkZ8k1_o2ua_459Mlv4syUdvxnPQivOjGPEXxDVvEMeta } from "/codebuild/output/src1349592404/src/src/pages/monthly/index.vue?macro=true";
import { default as indexHLXgyhg0M5Zm6gaJJ2BDdHpk_n89p2OgfOp9Pd_kmtwMeta } from "/codebuild/output/src1349592404/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexzBoot9G_45yFJQjem53jfvDZZqucq9Kraxz2cRzz7hkRQMeta } from "/codebuild/output/src1349592404/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavitHUB8F18byRo8vUHVdqqEQATBMGrZN8soSAflAPCpEkMeta } from "/codebuild/output/src1349592404/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit2RI7lTt58Eei6WEjdKkGwgQgk33OgYTjjQZID_45LWLzsMeta } from "/codebuild/output/src1349592404/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement5bB3sVzyB9UYyRjhqIpdKNZpNjTGezgLp9_45Nx1OkXvoMeta } from "/codebuild/output/src1349592404/src/src/pages/pass-agreement.vue?macro=true";
import { default as index1pNMkGP2E_5bXLcSRTHH7yej_454gU4fQX4K5b_45s6iNo8Meta } from "/codebuild/output/src1349592404/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dHUpLJ7k3YH0JsDJbm1RnELYW4ylQs4X7_45oCH2zwAB1MMeta } from "/codebuild/output/src1349592404/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmLRQ8FnVcxqvmg8qOePnx_K0Al7zeqHiczk_45A1xagcIcMeta } from "/codebuild/output/src1349592404/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexczmPBbUJyp5DAF_45eBPyHM3K07uASbNFNxNdt_jEq_45I4Meta } from "/codebuild/output/src1349592404/src/src/pages/card/create/index.vue?macro=true";
import { default as indexi1s_l_dNJAbc35nDWC7T_457ZjBAR_tjUyoqgq3vjviBcMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmHIKoixtO_qE38FmjZM0uAp2_45yMoEwmLIqDVu6P3OGv8Meta } from "/codebuild/output/src1349592404/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmd9uf2ZC1hw3lGO_45QjOijjGFs5D5LABQ1_kvKPkb7L3YMeta } from "/codebuild/output/src1349592404/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeKtWgu0S45jA52CkuqQ9mcX_45fIG60ki1LXVeJLKVzYwYMeta } from "/codebuild/output/src1349592404/src/src/pages/membership/complete.vue?macro=true";
import { default as registerpT_0VPME8I4Fe2mFafDLZnos61FdjAZ_45nzR2Xd491ksMeta } from "/codebuild/output/src1349592404/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93XulQp6MpLXRGFWTg6fhN3gYc3c_4qo52QM1cH9ZexLoMeta } from "/codebuild/output/src1349592404/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmPUNFYy7_452rmASZXWdQgnRM8EzitpT_sEdrDowL3gx6sMeta } from "/codebuild/output/src1349592404/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93EgdCOIrTbpzqBWeJN_45EA_rvSnwqDEu1YA_ZXLf5r5lsMeta } from "/codebuild/output/src1349592404/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexYchSo_CC7q26_450cGOeavXQjnG6K26537tsg8Av6gCwwMeta } from "/codebuild/output/src1349592404/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeOM5uf2zQAaXb9GXZdXqnj44Nqwaj8KNvtauxClSf0BIMeta } from "/codebuild/output/src1349592404/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeLrUrJGBDQ8dRFtPcRIP7ePLOHErHcpQ4JY6qYBYwkakMeta } from "/codebuild/output/src1349592404/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as complete743ILE8DoMQSvxoUrsxU1q7piu__6B7HKnev9e4uiNAMeta } from "/codebuild/output/src1349592404/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerA_45OYmdPbdO5K_7gr8J06Wwo349cAWwgS7kTGTtjaIscMeta } from "/codebuild/output/src1349592404/src/src/pages/contact-form/register.vue?macro=true";
import { default as completen0naZWOum2ikOZnkSPPWPz3oR4KPAhbOG9bHAggG3CQMeta } from "/codebuild/output/src1349592404/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index_CG8WaEQJ1dlqzy4iFxShNy8D_K7PS5JjzEdb_7WG_45AMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmCPiYFkUbWOH4lT0bm8L7fDpDv0EcDDCPtes8rGYXUv4Meta } from "/codebuild/output/src1349592404/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeYQMcBYXxT5lU3nnWUVsuPT_45Xju5D9dIfuiEyzIXeE0MMeta } from "/codebuild/output/src1349592404/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexPh_45ufMtt2eS42K_I6TDADtZEmeNVNl5mwOT1C8F0rUcMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93Y5467fMxw2Ss7AUZKmY3rDjtl4xJqOG9LKKtFj0M3OEMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeAiJdEI6IUMIB3ogH1hXKfxqVueNOgS1krw7msoWiFfAMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliastkhBZ7RoSt1UOi3y4M_7G5_5OqKaXxt0ZfOj99Al_7wMeta } from "/codebuild/output/src1349592404/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleqwvnB_UhItXde0AIcCgVpH13SJQJKVtfi70iey3p8SAMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailggW_UV9h3exSz0Z_Z2dnaSozpA7EWvUz67ZLPA4P6zYMeta } from "/codebuild/output/src1349592404/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmEEX_bTDPoKecm6FDqKz0DM2VloBLlWSBBfwml9O3xwMMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentvx3kXptH99Foc48oo0nnW8FLEZQ_JMv49qvYYdx2ItgMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm_bxvuzdIHpjWTo0IsIfMD5z86x2nv4FtCsgoqpwUE4IMeta } from "/codebuild/output/src1349592404/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateWl85h5AH5MxXxuSn3UeJrONKTQmZqvac4Ba7yfjFmZcMeta } from "/codebuild/output/src1349592404/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete_SG31V9Zb9jIoqvJBzxneOY4H_W4qv3HP9ozaIiwC4oMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeM9YinP5S4Rt2LS4Xl1YD2clkvS3H68HknWJp0TtPIQgMeta } from "/codebuild/output/src1349592404/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password6MmOf1bpcqTkj94IchTabwymSJVIgUUiO1ssULEoetYMeta } from "/codebuild/output/src1349592404/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasq6EPFykl4GKnfSef3uMWOMiRcqiBA8MR_45fnGiJmWaQkMeta } from "/codebuild/output/src1349592404/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerE_FvJEEaozNfWeYD3D8GWSqFyEYfED46YoY_zWLTXK8Meta } from "/codebuild/output/src1349592404/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codetfWCdaQAmiX06_L9u4KRMQS4S5tAOztsiUUpHydeoysMeta } from "/codebuild/output/src1349592404/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexh4qqcn22bU4Cd5c_KSq4NCrhDRqk_45huO7Y4AQyu2JsIMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index8nnZounzqRjL24jDtKR9MloNcMuToxt1WP_Gs2E1jhIMeta } from "/codebuild/output/src1349592404/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexEmR0vCeopNOvyxJ_45s5OPh_45I61f0ehEegld65TsLUEJMMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexbNSsa1_dn46wxWewcI3zG_UfF46G3qioxUZUYWy_45y_oMeta } from "/codebuild/output/src1349592404/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatez7jZFJfLTPmi_45_kCcdoGCeWCt4DtRdefGhWqZS6p7fMMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeaJ1PXRM1X_45LKY4L9oUhOjO5wVhrkl8bq6qkw6NswS8gMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmV24M3L7jesO9Tx3t3P3Anb_f6EHUlvsFW7uXOfmQZd0Meta } from "/codebuild/output/src1349592404/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexb6CYvBKP5_UBuwuJbQvAoMpOArFjtMFrlLhYOTWbqDwMeta } from "/codebuild/output/src1349592404/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeRFZ9oodAZDqxXTyLmWUlLo8jPJXiR8LU9McEnAbWAhYMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateezGerwipvUVv7oyoAgA0_4giN7RzXUytNDMQQyxOexcMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index_0QeGhVw8KfJdP3IDY6a0Eop_45plUXlBqJm8DwdnQfOIMeta } from "/codebuild/output/src1349592404/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexv2JfWRG80TEsX1dugeOHgJ0kgPqymY29UmBrgxbQigkMeta } from "/codebuild/output/src1349592404/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeoqlKtHYsv6OrArYvUixFKI_L6nxqcUmF7oTIf9Rxi_MMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexKQrDq73Ii0_45jJmPhITTXJ9Az0NLwpiGcHVoNjPidBm0Meta } from "/codebuild/output/src1349592404/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code5OL0MqOazw1kGKmvlq5jm0NcnX8Mi8BV_HmUUnYB4SIMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexu5Ms3eqrW_45LgkVIOGVzTNK0KeuibWGH_PHMVYigoOMIMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as index8UCHA00jr63pbEaTBehrJwZSGgo2zF6krFsBmBm8dXsMeta } from "/codebuild/output/src1349592404/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexw6ea_45rwXU_QQylmaJS904JIn1ZhAwSVYqdam995zkBsMeta } from "/codebuild/output/src1349592404/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateAAlOQZWPiRFcWCXvCDTwSs67en1FwNzGHyu5bScI8nAMeta } from "/codebuild/output/src1349592404/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm9vP6YUK8wTx4H_zuzlY72yQew0pcFhuXIRGX_45CqLZB0Meta } from "/codebuild/output/src1349592404/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuzFAx0cgZYpBGTVR_45rLM2m2LhWp4iSdGQY5Ppmc4Di_45QMeta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexjG9GtChtnwParDpx_xtPbchEsib1FSoNhG8j49kDyoMMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src1349592404/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexVMF4dSvM1Hz_459JhVJcfV_45Td_vR_45LBvsdLYd33uLmHnEMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1349592404/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexMlaVmAl2RYqCLKKc3FKF_p1h64uj5gmypRF22D7MJv4Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1349592404/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexHLXgyhg0M5Zm6gaJJ2BDdHpk_n89p2OgfOp9Pd_kmtwMeta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexzBoot9G_45yFJQjem53jfvDZZqucq9Kraxz2cRzz7hkRQMeta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexczmPBbUJyp5DAF_45eBPyHM3K07uASbNFNxNdt_jEq_45I4Meta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmHIKoixtO_qE38FmjZM0uAp2_45yMoEwmLIqDVu6P3OGv8Meta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmd9uf2ZC1hw3lGO_45QjOijjGFs5D5LABQ1_kvKPkb7L3YMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1349592404/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeKtWgu0S45jA52CkuqQ9mcX_45fIG60ki1LXVeJLKVzYwYMeta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerpT_0VPME8I4Fe2mFafDLZnos61FdjAZ_45nzR2Xd491ksMeta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmPUNFYy7_452rmASZXWdQgnRM8EzitpT_sEdrDowL3gx6sMeta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeOM5uf2zQAaXb9GXZdXqnj44Nqwaj8KNvtauxClSf0BIMeta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeLrUrJGBDQ8dRFtPcRIP7ePLOHErHcpQ4JY6qYBYwkakMeta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: complete743ILE8DoMQSvxoUrsxU1q7piu__6B7HKnev9e4uiNAMeta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerA_45OYmdPbdO5K_7gr8J06Wwo349cAWwgS7kTGTtjaIscMeta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmCPiYFkUbWOH4lT0bm8L7fDpDv0EcDDCPtes8rGYXUv4Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeYQMcBYXxT5lU3nnWUVsuPT_45Xju5D9dIfuiEyzIXeE0MMeta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexPh_45ufMtt2eS42K_I6TDADtZEmeNVNl5mwOT1C8F0rUcMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeAiJdEI6IUMIB3ogH1hXKfxqVueNOgS1krw7msoWiFfAMeta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleqwvnB_UhItXde0AIcCgVpH13SJQJKVtfi70iey3p8SAMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailggW_UV9h3exSz0Z_Z2dnaSozpA7EWvUz67ZLPA4P6zYMeta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmEEX_bTDPoKecm6FDqKz0DM2VloBLlWSBBfwml9O3xwMMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentvx3kXptH99Foc48oo0nnW8FLEZQ_JMv49qvYYdx2ItgMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm_bxvuzdIHpjWTo0IsIfMD5z86x2nv4FtCsgoqpwUE4IMeta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete_SG31V9Zb9jIoqvJBzxneOY4H_W4qv3HP9ozaIiwC4oMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeM9YinP5S4Rt2LS4Xl1YD2clkvS3H68HknWJp0TtPIQgMeta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password6MmOf1bpcqTkj94IchTabwymSJVIgUUiO1ssULEoetYMeta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerE_FvJEEaozNfWeYD3D8GWSqFyEYfED46YoY_zWLTXK8Meta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codetfWCdaQAmiX06_L9u4KRMQS4S5tAOztsiUUpHydeoysMeta || {},
    component: () => import("/codebuild/output/src1349592404/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1349592404/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]